import { createServiceFactory } from '@/services/factory'
import { createMockAssessmentService } from './assessments.mock'
import { createHttpAssessmentService } from './assessments.http'

export type {
  AssessmentService,
  AuthorizedAssessmentDetail,
  AuthorizedAssessmentPage,
} from './assessments.service'

export const getAssessmentService = createServiceFactory(
  'assessments',
  createMockAssessmentService,
  createHttpAssessmentService
)
